export default class MarketBase {
    typename: string = "";
    id: number = 0;
    AccessMask: number = 0;
    GlobalMask: number = 0;
    ModificationTS: string = "";
    CompositeName: string = "";
}